export const ENVIRONMENT = {
  production: false,
  moduleId: 'CKH35w4m_Ds-',
  moduleName: 'Analytics',
  appRoot: 'https://analytics.test.lautec.com/',
  coreModule: {
    id: '',
    name: 'Core',
    locationUrl: 'https://core.test.lautec.com/',
    favIconUrl:
      'https://assets.test.lautec.com/module-icons/favicon-core-module.svg',
    description: 'Account Management'
  },
  coreApi: {
    endpoint: 'https://api.core.test.lautec.com/v1',
    /**
     * Scopes you add here will be prompted for user consent during sign-in.
     * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
     * For more information about OIDC scopes, visit:
     * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
     */
    scopes: ['https://lautecb2ctest.onmicrosoft.com/apis/default']
  },
  azureAdB2C: {
    clientId: '12c86705-bfaf-46f8-8e4b-0224dddebbfc',
    b2cPolicies: {
      names: {
        signUpSignIn: 'b2c_1a_signin',
        passwordReset: 'b2c_1a_passwordreset'
      },
      authorities: {
        signUpSignIn: {
          authority:
            'https://identity.test.lautec.com/lautecb2ctest.onmicrosoft.com/b2c_1a_signin'
        },
        passwordReset: {
          authority:
            'https://identity.test.lautec.com/lautecb2ctest.onmicrosoft.com/b2c_1a_passwordreset'
        }
      },
      authorityDomain: 'identity.test.lautec.com'
    }
  },
  zendesk: {
    userEmailFieldId: '16824499290255',
    clientFieldId: '16836860495759',
    appFieldId: '16835044308495',
    appFieldValue: 'analytics',
    appVersionFieldId: '16836856280719',
    envFieldId: '16835076094351',
    envFieldValue: 'test'
  }
};
